module.exports = __webpack_public_path__ + "img/gm-read.1b9723d5.png";